var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_60672)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_971_60672",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_971_60672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.435 0H9.99805C7.34832 0.00791363 4.80937 1.06402 2.93572 2.93767C1.06207 4.81133 0.00596051 7.35027 -0.00195312 10C0.00569809 12.6498 1.06172 15.1889 2.93543 17.0626C4.80914 18.9363 7.34824 19.9923 9.99805 20C12.6479 19.9923 15.187 18.9363 17.0607 17.0626C18.9344 15.1889 19.9904 12.6498 19.998 10V9.563C19.9907 7.02901 18.9808 4.60091 17.1889 2.8091C15.3971 1.01729 12.969 0.00738701 10.435 0ZM13.076 6.129H11.96C11.085 6.129 10.916 6.545 10.916 7.155V8.5H13.004L12.732 10.608H10.92V16.015H8.74405V10.61H6.92505V8.502H8.74405V6.946C8.70721 6.57748 8.7514 6.20537 8.87354 5.85573C8.99567 5.5061 9.19278 5.1874 9.45106 4.92197C9.70935 4.65655 10.0225 4.45081 10.3687 4.31919C10.7149 4.18756 11.0857 4.13323 11.455 4.16C11.9978 4.15835 12.5403 4.18606 13.08 4.243L13.076 6.129Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_60672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon-fb.58f430b76419a0d8e24815f3fd4938c2.svg";
export { ForwardRef as ReactComponent };